export default __webpack_public_path__ + "static/media/pic8.59e0b436.jpg";